import script from "./Declined.vue?vue&type=script&setup=true&lang=ts"
export * from "./Declined.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__